var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component"},[_vm._l((_vm.content.split('\n')),function(line,index){return [(index !== 0)?_c('br',{key:("br-" + index)}):_vm._e(),_vm._v("\n    "+_vm._s(line)+"\n  ")]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }